<template>
  <div class="mainContainer">
    <div class="title">{{title}}</div>
    <div class="contentContainer">
      <div v-html="text" class="textGrow"></div>
        <ParallaxContainer>
          <ParallaxImage
            :width="432"
            :height="289"
            :factor="0.5"
          >
          <router-link :to="link"><img class="image" :src="src"/></router-link>   
          </ParallaxImage>
        </ParallaxContainer>
      </div>
  </div>
</template>

<script>
import ParallaxContainer from "./ParallaxContainer.vue";
import ParallaxImage from "./ParallaxImage.vue";
export default {
  name: "homeTile",
  props: ["text", "imgSrc", "left", "link", "title"],
  data() {
    return {
      src: require(`../assets/${this.imgSrc}`),
    };
  },
  components: {
    ParallaxContainer,
    ParallaxImage,
  },
};
</script>
<style>
.image {
  -webkit-transition: all 0.5s ease; /* Safari and Chrome */
  -moz-transition: all 0.5s ease; /* Firefox */
  -ms-transition: all 1s ease; /* IE 9 */
  -o-transition: all 1s ease; /* Opera */
  transition: all 1s ease;
}

.image:hover {
  -webkit-transform: scale(1.1); /* Safari and Chrome */
  -moz-transform: scale(1.1); /* Firefox */
  -ms-transform: scale(1.1); /* IE 9 */
  -o-transform: scale(1.1); /* Opera */
  transform: scale(1.1);
}

.contentContainer {
  display: flex;
  flex-direction: row;
  height: 100vh;
}
.title {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4rem;
  margin-bottom: 4rem;
}
.mainContainer {
  display: flex;
  height: 100vh;
  flex-direction: column;
}
.mainContainer:not(:last-child) {
  margin-bottom: 11rem;
}
.titleTile {
  margin-bottom: 50px;
}
.textGrow {
  flex-grow: 1;
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.innerSpan {
  margin: 0 10px;
  font-weight: bold;
  width: 155px;
  display: inline-block;
}
.line {
  border-bottom: 1px solid #d6961b;
  display: inline-block;
}
.left .line-left,
.right .line-right {
  width: 64%;
}
.right .line-left,
.left .line-right {
  width: calc(31% - 155px);
}
.imagePara {
  width: 100%;
  margin-bottom: 30px;
}

.imagePara p {
  display: inline-block;
  width: 36%;
  text-align: left;
  vertical-align: middle;
  font-size: x-large;
  text-indent: 2em;
}
.right p.paraImage {
  padding-right: 10%;
}
.left p.paraImage {
  padding-left: 10%;
}
.imagePara img {
  display: inline-block;
  width: 54%;
  border-radius: 5%;
  vertical-align: middle;
}
.titleDiv h1 {
  font-size: 5em;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    visibility: visible;
    opacity: 1;
  }
}
@keyframes fadeInSlow {
  0% {
    opacity: 0;
  }
  33% {
    opacity: 0;
  }
  100% {
    visibility: visible;
    opacity: 1;
  }
}
@media only screen and (min-width: 812px) {
  .imagePara img {
    animation-fill-mode: forwards;
    visibility: visible;
  }
}
@media only screen and (min-width: 319px) and (max-width: 812px) {
  .innerSpan {
    width: 150px;
    text-align: center;
  }
  .imagePara img,
  .imagePara p {
    width: 95%;
  }
  .left .line-left,
  .right .line-right {
    width: 100%;
  }
  .right .line-left,
  .left .line-right {
    width: 100%;
  }
  .titleTile {
    text-align: center;
    margin-bottom: 10px;
  }
  .right p.paraImage {
    padding-right: 1%;
  }
  .left p.paraImage {
    padding-left: 1%;
  }
}
</style>
